import type { Translations } from '../../../types'

const shopValidationMessages: Translations = {
  "shop.validation.product.nameRequired": "Nome prodotto obbligatorio",
  "shop.validation.product.categoryRequired": "Seleziona almeno una categoria",
  "shop.validation.product.priceRequired": "Prezzo obbligatorio",
  "shop.validation.product.priceInvalid": "Prezzo non valido",
  "shop.validation.product.quantityRequired": "Quantita obbligatoria",
  "shop.validation.product.quantityInvalid": "Quantita non valida",
}

export default shopValidationMessages
